import { render, staticRenderFns } from "./HomeNotificationCard.vue?vue&type=template&id=59c547d8&scoped=true"
import script from "./HomeNotificationCard.vue?vue&type=script&lang=js"
export * from "./HomeNotificationCard.vue?vue&type=script&lang=js"
import style0 from "./HomeNotificationCard.vue?vue&type=style&index=0&id=59c547d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c547d8",
  null
  
)

export default component.exports